// Tags row view component with dropdown button at left. Just view, no logic.
<template>
  <div class="wrapper">
    <div class="container">
      <BaseBtn v-if="!hideButton || !isLoading" @click="onMoreTagsClick" class="modal-btn">
        <div class="btn-text">{{ text }}</div>
        <div class="action-text">{{ actionText }}</div>
      </BaseBtn>
      <SkeletonWrapper :isLoading="isLoading">
        <div class="tags" :class="{hideBtn: hideButton}">
          <Tag
            v-for="tag in tags"
            :tag="{...tag, isActive: tag.value}"
            :key="tag.id"
            @click="toggleTag(tag)"
            :class="{'tag-withcheckmark': tag.value}"
            :showDomain="showTagsDomain"
            :withCheck="showTagChecks && tag.value"
          />
        </div>
      </SkeletonWrapper>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {computed} from '@vue/composition-api';
import BaseBtn from '@common/button/button.vue';
import Tag from '@common/filter-tag/tag.vue';
import SkeletonWrapper from '@common/skeleton-wrapper.vue';

Vue.use(VueCompositionAPI);

export default {
  setup(props, {emit}) {
    function selectedTags() {
      return props.tags.filter((tag) => tag.value);
    }

    function toggleTag(tag) {
      if (!tag.disabled) {
        emit('toggle-tag', [{...tag, value: !tag.value}]);
      }
    }

    const isVisibleShowMore = computed(() => {
      return props.tags.length > 10;
    });

    function onMoreTagsClick() {
      emit('dropdown-click');
    }

    return {selectedTags, toggleTag, onMoreTagsClick, isVisibleShowMore};
  },

  name: 'TagsRow',
  props: ['tags', 'text', 'actionText', 'isLoading', 'showTagsDomain', 'showTagChecks', 'hideButton', 'hideMore'],
  components: {
    Tag,
    BaseBtn,
    SkeletonWrapper,
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  overflow: hidden;
  display: flex;
  align-items: baseline;
}

.container {
  position: relative;
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
}

.btn-text {
  line-height: 1;
  letter-spacing: normal;
}

.action-text {
  padding-right: 10px;
  position: relative;
  color: var(--font-color-light);
  font-size: 12px;
  font-weight: normal;
}

.action-text::after {
  content: '';
  top: -1px;
  right: -4px;
  position: absolute;
  width: 16px;
  height: 100%;
  background-image: url(./icon-filter-downarrow.svg);
  opacity: 0.5;
  background-size: 8px;
  background-position: center right;
  background-repeat: no-repeat;
}

.tags::-webkit-scrollbar {
  display: none;
}

.modal-btn {
  width: auto;
  min-width: unset;
  position: absolute;
  padding: 8px 10px 0 0;
  text-align: left;
  color: var(--font-color-dark);
  font-weight: bold;
  font-size: 14px;
  border: none;
  background-color: transparent;
  border-radius: 0;
}

.more-btn {
  position: relative;
  padding: 0 10px;
  color: var(--font-color-dark);
  border: none;
  background-color: transparent;
  border-radius: 0;
  color: var(--font-color-light);
  font-size: 12px;
  font-weight: normal;
  min-width: 80px;
  height: auto;
}

.more-btn::after {
  content: '';
  top: 4px;
  right: -2px;
  position: absolute;
  width: 16px;
  height: 100%;
  background-image: url(./icon-filter-downarrow.svg);
  opacity: 0.5;
  background-size: 8px;
  background-position: center right;
  background-repeat: no-repeat;
  transform: rotate(-90deg);
}

.tags {
  margin-left: 86px;
  display: flex;
  overflow: auto;
  width: 100%;
}

.tags.hideBtn {
  margin-left: 0;
}
.filtersWrapper-tegs-row .tags {
  margin-left: 15px;
}
</style>
